import { API_URL } from "../config";
import { isString } from "lodash";
import { isEmpty } from "lodash";
import { fetchJson } from "./fetch";

export interface Result<T> {
  headers: Headers;
  data: T;
  body: string;
  status: number;
}

export async function request<T>(
  path: String,
  options?: { [key: string]: any }
): Promise<Result<T | undefined>> {
  let reqUrl = `${API_URL}` + path;
  let requestInit = {
    ...options,
  };
  if (options && options.data && !isString(options.data)) {
    requestInit.body = new URLSearchParams(options.data);
  }
  if (options && !isEmpty(options.params)) {
    let u = new URL(reqUrl);
    u.search = new URLSearchParams(options.params).toString();
    reqUrl = u.toString();
  }
  const res = await fetchJson(reqUrl, requestInit);
  return res;
}
